import { GridPaginationModel } from '@mui/x-data-grid-pro';
import { Dispatch, SetStateAction, useCallback, useState } from 'react';

export interface UseGridPaginationReturn {
  paginationModel: GridPaginationModel;
  setPaginationModel: Dispatch<SetStateAction<GridPaginationModel>>;
  handlePaginationChange: (
    _: React.MouseEvent<HTMLButtonElement> | null,
    page: number,
  ) => void;
  handlePageOptionChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
}

export const useGridPagination = (
  initialModel: GridPaginationModel,
): UseGridPaginationReturn => {
  const [paginationModel, setPaginationModel] =
    useState<GridPaginationModel>(initialModel);

  const handlePaginationChange = useCallback(
    (_: React.MouseEvent<HTMLButtonElement> | null, page: number): void => {
      setPaginationModel(prev => ({ ...prev, page }));
    },
    [],
  );

  const handlePageOptionChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
      const pageSize = parseInt(e.target.value, 10);
      setPaginationModel({ page: 0, pageSize });
    },
    [],
  );

  return {
    paginationModel,
    setPaginationModel,
    handlePaginationChange,
    handlePageOptionChange,
  };
};
